import {
  Component,
  OnInit,
  Output,
  HostListener,
  Input,
  ElementRef,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent implements OnInit {
  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.eRef.nativeElement.contains(event?.target)) {
      this.openOptions = false;
    }
  }

  @Input() selectValue!: any;
  @Input() selectData!: any;
  @Input() key!: string;
  @Output() selectOutput = new EventEmitter<string>();

  public select!: string;
  public openOptions: boolean = false;
  private focusedOptionIndex: number = -1;

  constructor(private eRef: ElementRef) {}

  ngOnInit(): void {
    this.select = this.selectData ? this.selectData[0].option : null;
  }

  get labelId(): string {
    return `select-label-${this.key}`;
  }

  getOptionId(index: number): string {
    return `select-option-${this.key}-${index}`;
  }

  openOption(): void {
    this.openOptions = !this.openOptions;
    if (this.openOptions) {
      this.focusedOptionIndex = -1;
    }
  }

  onChange(el: any): void {
    this.selectValue = el.name;
    this.selectOutput.emit(el);
    this.openOptions = false;
  }

  onKeydown(event: KeyboardEvent): void {
    switch (event.key) {
      case 'Enter':
      case ' ':
        this.openOption();
        event.preventDefault();
        break;
      case 'ArrowDown':
        if (!this.openOptions) {
          this.openOption();
        } else {
          this.focusNextOption();
        }
        event.preventDefault();
        break;
      case 'ArrowUp':
        if (this.openOptions) {
          this.focusPreviousOption();
          event.preventDefault();
        }
        break;
      case 'Escape':
        if (this.openOptions) {
          this.openOptions = false;
          event.preventDefault();
        }
        break;
    }
  }

  onOptionKeydown(event: KeyboardEvent, option: any, index: number): void {
    switch (event.key) {
      case 'Enter':
      case ' ':
        this.onChange(option);
        event.preventDefault();
        break;
      case 'ArrowDown':
        this.focusNextOption();
        event.preventDefault();
        break;
      case 'ArrowUp':
        this.focusPreviousOption();
        event.preventDefault();
        break;
      case 'Escape':
        this.openOptions = false;
        event.preventDefault();
        break;
    }
  }

  private focusNextOption(): void {
    if (this.focusedOptionIndex < this.selectData.length - 1) {
      this.focusedOptionIndex++;
      this.focusOption(this.focusedOptionIndex);
    }
  }

  private focusPreviousOption(): void {
    if (this.focusedOptionIndex > 0) {
      this.focusedOptionIndex--;
      this.focusOption(this.focusedOptionIndex);
    }
  }

  private focusOption(index: number): void {
    const optionElement = this.eRef.nativeElement.querySelector(
      `#${this.getOptionId(index)}`
    );
    if (optionElement) {
      optionElement.focus();
    }
  }

  trackByOption(index: number, option: any): string {
    return (
      option?.value ??
      option?.option ??
      option?.name ??
      option?.label ??
      `${index}`
    );
  }
}
